import KlariticsSDK from "./KlariticsSDK";
import Logger from "./Logger";
import type { Event } from "./types/types";

/**
 * Define the structure of the Klaritics stub and the SDK for the global window object.
 */
interface KlariticsStub {
  _q: any[];
  _st: number;
  logEvent(): void;
}

declare global {
  interface Window {
    Klaritics: KlariticsSDK | KlariticsStub;
    KlariticsLogger: typeof Logger;
  }
  // If you are using CommonJS environment variables
  var exports: any;
  var module: any;
}

// Initialize the stub if it doesn't exist
window.Klaritics = window.Klaritics || { _q: [], _st: Date.now() };

/**
 * Access the queue from the existing window object.
 * Note: We cast to KlariticsStub to safely access _q before the SDK replaces it.
 */
const existingStub = window.Klaritics as KlariticsStub;

// Instantiate the SDK, passing the stub's queue in directly via the
// constructor — this runs BEFORE _init() drains the queue, so there's
// no race with class-field initialization order.
const klariticsSDK = new KlariticsSDK(
  window,
  +(existingStub._st ?? Date.now()),
  existingStub._q
);

// Replace the stub with the real instance
window.Klaritics = klariticsSDK;
window.KlariticsLogger = Logger;

export default klariticsSDK;
